module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unm-header"
  }, [_c('div', {
    staticClass: "navbar navbar-unm"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "https://degrees.unm.edu"
    }
  }, [_vm._v("The University of New\n        Mexico")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right hidden-xs",
    attrs: {
      "id": "toolbar-nav"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu/departments/",
      "title": "UNM A to Z"
    }
  }, [_vm._v("UNM A-Z")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://my.unm.edu",
      "title": "myUNM"
    }
  }, [_vm._v("myUNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu",
      "title": "Directory"
    }
  }, [_vm._v("Directory")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "department logo block",
      "id": "header",
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa129208","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unm_header.vue
// module id = 1140
// module chunks = 1